const REQUEST_TYPE_CONTENT_TYPE_MAP = new Map([
    ['binary', 'application/octet-stream'],
    ['json', 'application/json'],
    ['string', 'text/plain'],
]);
export function setRequestContentType(headers, requestType) {
    if (requestType && REQUEST_TYPE_CONTENT_TYPE_MAP.has(requestType) && !headers.get('Content-Type')) {
        headers.set('Content-Type', REQUEST_TYPE_CONTENT_TYPE_MAP.get(requestType));
    }
}
//# sourceMappingURL=setRequestContentType.js.map